import { toast } from "react-toastify";
import { UserRoleE } from "../models/enums";
import { RoutesE } from "../routes/routesData";
import { toggleLoading } from "../store/slices/appSlice";
import { DEFAULT_ADVERTISER_AGENCY_ID, DEFAULT_POST_PRODUCTION_COMPANY_ID, DEFAULT_PRODUCTION_COMPANY_ID, MEDIA_COMPANY_NONE_ID } from "../utils/constants";
import { TOAST_DURATION } from "../utils/helpers/constants";
import { trimObjectFields } from "../utils/helpers/trimObjectFields";

/**
 * Uses when you want to UPDATE or COPY existing campaign
*/

export const handleUpdateCampaign = async (
    campaignData: any,
    addToExist: string,
    campaignRetry: boolean,
    removePopup: () => void,
    updateProject: (body: any) => void,
    dispatch: (action: any) => void,
    navigate: (action: any) => void,
    fetchAllProjects: (action: any) => void,
    searchParams: any,
    user: any
) => {

    const body = {
        ...campaignData,
        BrandId: campaignData.BrandId.value,
        IndustryId: campaignData.IndustryId.value,
        AdvertiserId: campaignData.AdvertiserId.value,
        // "Self Media Buy" (sentinel) persists as no FK (null); a real selection sends its client id.
        // Mirrors mapCampaignDataForSubmitting.ts so both wizards write MediaCompanyId identically.
        MediaCompanyId: campaignData.MediaCompanyId?.value === MEDIA_COMPANY_NONE_ID ? null : (campaignData.MediaCompanyId?.value ?? null),
        Versions: campaignData.Versions,
        ProductionLocationIsrael: campaignData.ProductionLocationIsrael === 'local',
        PostProductionCompanyId: campaignData.PostProductionCompanyId?.value || DEFAULT_POST_PRODUCTION_COMPANY_ID,
        ProductionCompanyId: campaignData.ProductionCompanyId?.value || DEFAULT_PRODUCTION_COMPANY_ID,
        AdvertisingAgencyId: DEFAULT_ADVERTISER_AGENCY_ID,
        AdvertisingAgencyName: campaignData?.AdvertisingAgencyName?.value || campaignData.AdvertisingAgencyId?.label,
        ParticipantNames: campaignData.ParticipantNames || (user.culture === 'he-IL' ? 'אין' : 'NONE'),
        SpeakerNames: campaignData.SpeakerNames || (user.culture === 'he-IL' ? 'אין' : 'NONE'),
        ProjectType: "VideoAd",
        Campaign: {
            CampaignId: campaignData.Id,
        },
        BroadcasterIds: campaignData.selectedChannels.join(','),
        broadcasters: [],
        addToExist,
        campaignRetry,
    };

    delete body.selectedChannels;
    delete body.campaignId;
    
    const res: any = await updateProject(trimObjectFields(body));
    if (res.error) {
        return
    }
    dispatch(toggleLoading());
    await fetchAllProjects({
        take: 10,
        page: 1,
        limit: 10,
        statusName: searchParams.get('status'),
        sort: searchParams.get('sorting'),
        filterType: searchParams.get('filterType'),
        filter: searchParams.get('filter'),
    });
    dispatch(toggleLoading());
    // navigate(`/projects/viewVideoAd/${res.Id}`);
    if (user.role !== UserRoleE.DeliveryService) {
        removePopup();
        toast('Successfully updated', {
            type: 'success',
            autoClose: TOAST_DURATION,
        });
        navigate(RoutesE.PROJECTS);
    } else {
        navigate(0);
    }
};